export default __webpack_public_path__ + "static/media/O-131.92223e9e.png";